<template lang="pug">
v-dialog(v-model="dialogAdd" width="700" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-2(v-if="!itemIsNull" small color="blue" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-square-edit-outline
        v-btn.ml-10(v-else small color="green" dark v-bind="attrs" v-on="on")
            v-icon(small) mdi-plus-circle
            | &nbsp; Add New Profile Template

    v-card
        v-card-title {{ itemIsNull ? 'Add New' : 'Update' }} Profile Template
        v-card-text
            v-text-field(label="Name" v-model="form.name" :disable="dialogAddLoading")

            v-file-input(
                v-model="imageForm"
                :disabled="dialogAddLoading"
                placeholder="Select Image"
            ) Select File

            v-combobox(v-model="form.type" label="Type" :items="['AVATAR', 'AVATAR_FRAME', 'PROFILE_BACKGROUND', 'TOP_BACKGROUND', 'LOWER_BACKGROUND']" :disable="dialogAddLoading")
            
        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!dialogAddLoading" small color="red" text @click="dialogAdd = false") Cancel
            v-btn(small color="primary" text @click="addProfileTemplate" :loading="dialogAddLoading") Submit
</template>

<script>
import { mapActions } from 'vuex';
import Config from '../../../../configuration';

export default {
    props: {
        item: {
            type: Object,
            default() {
                return {
                    name: null,
                    image: null,
                    type: null
                };
            }
        }
    },
    data() {
        return {
            dialogAdd: false,
            dialogAddLoading: false,
            imageForm: null,
            form: {
                name: this.item.name,
                image: this.item.image,
                type: this.item.type
            },
            successMessage: false,
            error: {
                show: false,
                message: ''
            }
        };
    },
    computed: {
        methodOptions() {
            return [
                { id: 'CREATE', text: 'Create' },
                { id: 'UPDATE', text: 'Update' }
            ];
        },
        itemIsNull() {
            return !this.item || !this.item.name && !this.item.description;
        }
    },
    methods: {
        async addProfileTemplate() {
            this.dialogAddLoading = true;
            try {
                if(this.itemIsNull) {
                    if(!this.imageForm) {
                        throw new Error('Image required!');
                    }
                    const profilePictureRaw = await this.toBase64(this.imageForm);
                    const profileS3File = await fetch(`${Config.host}/api/upload`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': window.localStorage.getItem('feathers-jwt')
                        },
                        body: JSON.stringify({
                            uri: profilePictureRaw
                        })
                    }).then(data => data.json());
                    this.form.image = `https://api.breakinghits.com/public/${profileS3File.id}`;
                    await this.createProfileTemplate({
                        ...this.form
                    });
                    this.$emit('success')
                    this.form.name = null;
                    this.form.image = null;
                    this.form.type = null;
                    this.imageForm = null;
                    this.dialogAdd = false;
                } else {
                    if(this.imageForm) {
                        const profilePictureRaw = await this.toBase64(this.imageForm);
                        const profileS3File = await fetch(`${Config.host}/api/upload`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': window.localStorage.getItem('feathers-jwt')
                            },
                            body: JSON.stringify({
                                uri: profilePictureRaw
                            })
                        }).then(data => data.json());
                        this.item.image = `https://api.breakinghits.com/public/${profileS3File.id}`;
                    }
                    this.item.name = this.form.name;
                    this.item.type = this.form.type;
                    await this.item.patch();
                    this.$emit('success');
                    this.dialogAdd = false;
                }
            } catch(err) {
                this.$emit('error', err)
            } finally {
                this.dialogAddLoading = false;
            }
        },
        servicesFilter(items) {
            return [
                'authentication',
                ...(items.map(i => i.id).filter(service => [
                    'logic-control',
                    'cities',
                    'countries',
                    'regions',
                    'logic-control-category',
                    'bh-app-error-log',
                    'bh-app-version',
                    'bh-exp-tables',
                    'access-control-services',
                    'bh-user-obtained-exp',
                    'bh-exp-hooks'
                ].indexOf(service) === -1))
            ];
        },
        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        ...mapActions('bh-profile-templates', { createProfileTemplate: 'create' })
    }
}
</script>